import axios from 'axios';

// Create a separate axios instance for abTest API calls
// The rule-manager API is publicly accessible, so CSRF token verification is not required
const abTestAxios = axios.create();
abTestAxios.interceptors.request.use((config) => {
  delete config.headers['X-CSRF-Token'];
  return config;
});

const abTestService = {
  getVariation: async ({ name, distinct_id }, domain) => {
    try {
      const response = await abTestAxios.post(
        `https://${domain}/v1/rules/evaluate`,
        {
          name,
          distinct_id,
        },
      );
      return response;
    } catch (error) {
      console.error('Error fetching AB test variation:', error);
      // Return control as fallback when API call fails
      return { data: { data: { group: 'control' } } };
    }
  },
};

export default abTestService;
